import { render } from "./QuailatyFeatures.vue?vue&type=template&id=e2eafdf2"
import script from "./QuailatyFeatures.vue?vue&type=script&lang=js"
export * from "./QuailatyFeatures.vue?vue&type=script&lang=js"

import "./QuailatyFeatures.vue?vue&type=style&index=0&id=e2eafdf2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__